import { render } from "./DeviceDetailModal.vue?vue&type=template&id=7b3ef8b8&ts=true"
import script from "./DeviceDetailModal.vue?vue&type=script&lang=ts"
export * from "./DeviceDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__